import React from 'react';
import classNames from 'classnames';
import '../dashboard.css';
import { clampPercent } from './format';

export type KpiTone = 'brand' | 'green' | 'blue' | 'amber';

interface KpiCardProps {
  label: string;
  /** bootstrap-icons name, e.g. "bi-clipboard-check". */
  icon: string;
  tone: KpiTone;
  value: React.ReactNode;
  /** Muted line under the value. Ignored when `progress` is given. */
  sub?: React.ReactNode;
  /** 0–100: renders a 6px bar instead of the sub-line. */
  progress?: number;
  progressTone?: 'brand' | 'green';
  loading?: boolean;
}

const KpiCard: React.FC<KpiCardProps> = ({
  label,
  icon,
  tone,
  value,
  sub,
  progress,
  progressTone = 'brand',
  loading = false,
}) => (
  <div className="dash-kpi">
    <div className="dash-kpi-head">
      <span className="dash-kpi-label">{label}</span>
      <span className={`dash-chip dash-chip-${tone}`} aria-hidden="true">
        <i className={`bi ${icon}`} />
      </span>
    </div>
    {loading ? (
      <>
        <span className="dash-skel" style={{ height: 32, width: '45%' }} />
        <span className="dash-skel" style={{ height: 12, width: '70%' }} />
      </>
    ) : (
      <>
        <div className="dash-kpi-value">{value}</div>
        {progress !== undefined ? (
          <div
            className={classNames('dash-bar', { 'dash-bar-green': progressTone === 'green' })}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={clampPercent(progress)}
            aria-label={label}
          >
            <span style={{ width: `${clampPercent(progress)}%` }} />
          </div>
        ) : (
          sub !== undefined && <div className="dash-kpi-sub">{sub}</div>
        )}
      </>
    )}
  </div>
);

export default KpiCard;
